import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers';

function DateTimePickerBasic({
  value,
  format = 'YYYY-MM-DD HH:mm',
  views = ['year', 'month', 'day', 'hours', 'minutes'],
  minDate,
  maxDate,
  disabled = false,
  currentLocale = 'en',
  slotProps,
  sx,
  onChange = (e) => {}, //func
}) {
  // 마운트 시 언어팩 로드
  React.useEffect(() => {
    loadLocaleData(currentLocale);
  }, []);

  const onChangeButton = (e) => {
    onChange(e);
  };

  // 동적으로 언어팩을 로드하는 함수
  const loadLocaleData = async (locale) => {
    try {
      await import(`dayjs/locale/${locale}.js`);
    } catch (error) {
      console.error('언어팩 로드 실패:', error);
    }
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={currentLocale}
      dateFormats={{
        // Day.js 형식 변경
        dayjs: 'YYYY-MM-DD',
      }}
    >
      <DateTimePicker
        value={value}
        disabled={disabled}
        format={format}
        maxDate={maxDate}
        minDate={minDate}
        views={views}
        sx={sx}
        slotProps={slotProps}
        onChange={onChangeButton}
      />
    </LocalizationProvider>
  );
}

export default React.memo(DateTimePickerBasic);
